module.exports = "/_next/static/images/counter-aeac93196a4c3407b3061a07eddf421b.jpg";